import React, { FC, useState } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const dadosTexto = {
  Titulo: 'O QUE FALAM SOBRE A GENTE',
  Texto: 'Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.'
};

const testemunhoData = definicoescliente?.Testemunho?.Depoimento || [
  {
    Imagem: '/images/t1.png',
    Nome: 'Yasmin Silva',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t2.png',
    Nome: 'Thiago Oliveira',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t3.png',
    Nome: 'Rousilene Amparo',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    Imagem: '/images/t4.png',
    Nome: 'Maira Roberta',
    Descricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
];

const Testemunho: FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slideAnterior = () => {
    const isFirstSlide = currentIndex === 0;
    setCurrentIndex(isFirstSlide ? testemunhoData.length - 1 : currentIndex - 1);
  };

  const slidePosterior = () => {
    const isLastSlide = currentIndex === testemunhoData.length - 1;
    setCurrentIndex(isLastSlide ? 0 : currentIndex + 1);
  };

  return (
    <section id="testemunhos" className="text-center mt-10 px-6 lg:px-14 bg-theme-gray py-12">
      <h2 className="text-textotitulo font-bold mb-4">{definicoescliente?.Testemunho?.Titulo || dadosTexto.Titulo}</h2>
      <p className="text-gray-600 text-textopadrao mb-10 max-w-xl mx-auto">
        {definicoescliente?.Testemunho?.Descricao || dadosTexto.Texto}
      </p>

      <div className="relative flex justify-center items-center">
        {/* Botão anterior */}
      <div className="absolute top-1/2 left-0 transform -translate-y-1/2 p-6">
        <button
          onClick={slideAnterior}
          className="transition duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-chevron-left hover:text-theme-secondary transition duration-200 cursor-pointer"
            viewBox="0 0 16 16">
            <path
              fillRule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          </svg>
        </button>
      </div>

        {/* Slide atual */}
        <div className="flex flex-col items-center bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
          <img src={testemunhoData[currentIndex].Imagem} alt={testemunhoData[currentIndex].Nome} className="rounded-full w-24 h-24 mb-4 object-cover"/>
          <h3 className="text-textotitulo font-semibold mb-2">{testemunhoData[currentIndex].Nome}</h3>
          <p className="text-theme-dark text-textopadrao mb-4">{testemunhoData[currentIndex].Descricao}</p>
        </div>

        {/* Botão próximo */}
        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 p-6">
          <button
            onClick={slidePosterior}
            className="transition duration-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              fill="currentColor"
              className="bi bi-chevron-right hover:text-theme-secondary transition duration-200 cursor-pointer"
              viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M4.646 14.354a.5.5 0 0 1 0-.708L10.293 8 4.646 2.354a.5.5 0 1 1 .708-.708l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708 0z"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testemunho;
